import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import formatPrescriberName from 'utils/formatPrescriberName';

import OrderViewInformationSection from './OrderViewInformationSection';
import OrderViewInformationSectionTitle from './OrderViewInformationSectionTitle';

const OrderViewInformationPrescriber = ({ Prescriber }) => (
  <OrderViewInformationSection>
    <Grid
      container
      direction="column"
      justify="flex-start"
      spacing={0}
    >
      <Grid item>
        <OrderViewInformationSectionTitle>
          Prescriber
        </OrderViewInformationSectionTitle>
      </Grid>
      <Grid item>
        <Typography>
          {formatPrescriberName(Prescriber)}
          {Prescriber.NPI && ` (NPI: ${Prescriber.NPI})`}
        </Typography>
      </Grid>
    </Grid>
  </OrderViewInformationSection>
);

OrderViewInformationPrescriber.propTypes = {
  Prescriber: PropTypes.shape({
    'First Name': PropTypes.string.isRequired,
    'Last Name': PropTypes.string.isRequired,
    'Name Prefix': PropTypes.string,
    'Name Suffix': PropTypes.string,
    Credential: PropTypes.string,
    NPI: PropTypes.string,
  }).isRequired,
};

export default OrderViewInformationPrescriber;



// WEBPACK FOOTER //
// ./src/components/workflow/OrderViewInformation/OrderViewInformationPrescriber.js